import { render, staticRenderFns } from "./CoordSelector.vue?vue&type=template&id=6632838d"
import script from "./CoordSelector.vue?vue&type=script&lang=js"
export * from "./CoordSelector.vue?vue&type=script&lang=js"
import style0 from "./CoordSelector.vue?vue&type=style&index=0&id=6632838d&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports